import { render } from "./splitOrderModel.vue?vue&type=template&id=257292f0"
import script from "./splitOrderModel.vue?vue&type=script&lang=js"
export * from "./splitOrderModel.vue?vue&type=script&lang=js"

import "./splitOrderModel.vue?vue&type=style&index=0&id=257292f0&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__